import { module } from 'modujs';
import { html } from '../utils/environment';
import { gsap } from 'gsap';
import { shuffle } from '../utils/array'
import lottie from 'lottie-web';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                'menu-toggler': 'toggleMenu'
            }
        }
    }

    // ==========================================================================
    // INIT METHODS
    // ==========================================================================
    init() {
        this.currentTemplate = html.getAttribute('data-page')

        this.$menuBg = this.$('menu-bg')[0]
        this.setState('idle');
        this.setMenuBgSize();

        this.handleInteractions()
        this.initFaces();
    }

    initFaces() {
        this.$faces = this.$('faces')[0]

        this.segments = shuffle(this.getData('lottie-segments', this.$faces).split(';').map(item => { return item.split(',').map(item => parseInt(item)) }))
        this.segmentIndex = 0;

        this.errorSegment = this.getData('lottie-error-segment', this.$faces).split(',').map(item => parseInt(item));

        this.animation = lottie.loadAnimation({
            container: this.$faces,
            autoplay: false,
            loop: false,
            path: `${this.getData('lottie-file', this.$faces)}`,
            // renderer: 'canvas',
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid meet'
            }
        })

        this.animation.addEventListener('complete', (e) => {
            this.setState('idle')
        })
    }

    // ==========================================================================
    // INTERACTION / COMPUTING METHODS
    // ==========================================================================
    handleInteractions() {
        // HAMBURGER
        this.$menuToggler = this.$('menu-toggler')[0]
        this.$menuToggler.addEventListener('mouseenter', () => {
            if(!html.classList.contains('has-menu-opened') && !html.classList.contains('is-loading')) {
                this.setState('idle')
                this.stopFaces();
            }
        })

        this.$menuToggler.addEventListener('mouseleave', () => {
            if(!html.classList.contains('has-menu-opened') && !html.classList.contains('is-loading')) {
                this.resumeFaces()
            }
        })

        // GLOBAL EVENTS
        window.addEventListener('keydown', this.onKeyDown = e => {
            // Escape key
            if(e.keyCode === 27) {
                this.closeMenu()
            }
        })
        this.checkResizeBind = this.checkResize.bind(this)
        window.addEventListener('resize', this.checkResizeBind)
    }

    // Resize
    // ==========================================================================
    checkResize() {
        if(!this.resizeTick) {
            this.resizeTick = true
            requestAnimationFrame(() => {
                this.onResize()
                this.resizeTick = false
            })
        }
    }

    onResize() {
        this.setMenuBgSize();
    }

    // Menu methods
    // ==========================================================================
    toggleMenu() {
        if(html.classList.contains('has-menu-opened')) {
            this.closeMenu()
        } else {
            this.openMenu()
        }
    }

    openMenu() {
        html.classList.add('has-menu-opened')

        this.setState('close');
    }

    closeMenu() {
        html.classList.remove('has-menu-opened')

        this.setState('idle');
    }

    setMenuBgSize() {
        const size = Math.sqrt(Math.pow(window.innerWidth/2, 2) + Math.pow(window.innerHeight,2)) * 2;
        gsap.set(this.$menuBg, { width: size, height: size });
    }

    // Hamburger methods
    // ==========================================================================
    setState(id) {
        this.el.querySelector('.is-active').classList.remove('is-active')
        this.$(id)[0].classList.add('is-active')

        if(id == 'idle') {
            this.resumeFaces();
        } else {
            this.stopFaces();
        }
    }

    resumeFaces() {
        this.stopFaces();

        this.faceTimeout = setTimeout(() => {
            this.setState('faces')

            let segment;
            if(this.currentTemplate == '404') segment = this.errorSegment;
            else segment = this.segments[this.segmentIndex % this.segments.length];

            this.animation.playSegments(segment, true)
            this.segmentIndex++;
        }, 6000);
    }

    stopFaces() {
        if(this.animation && this.animation.pause) this.animation.pause()
        if(this.faceTimeout) clearTimeout(this.faceTimeout);
        this.faceTimeout = null;
    }

    // ==========================================================================
    // DESTROY
    // ==========================================================================
    destroy() {
        super.destroy();

        window.removeEventListener('keydown', this.onKeyDown)
        window.removeEventListener('resize', this.checkResizeBind)

        if(this.animation && this.animation.destroy) {
            this.animation.destroy()
            delete this.animation;
        }
    }
}
